import React from "react";

const HotelPlaceholder = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="225"
      height="225"
      viewBox="0 0 255 255"
      xmlSpace="preserve"
      className={className}
    >
      <g
        style={{
          stroke: "none",
          strokeWidth: 0,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "none",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          d="M 45 84.383 c -0.293 0 -0.572 -0.129 -0.762 -0.353 L 19.55 54.955 c -5.114 -6.029 -7.931 -13.69 -7.931 -21.574 C 11.619 14.975 26.594 0 45 0 C 53.917 0 62.3 3.472 68.604 9.777 c 6.305 6.305 9.777 14.688 9.776 23.604 c 0 7.884 -2.816 15.545 -7.931 21.573 L 45.763 84.03 C 45.573 84.254 45.294 84.383 45 84.383 z M 45 2 C 27.697 2 13.619 16.078 13.619 33.381 c 0 7.41 2.648 14.612 7.456 20.28 L 45 81.838 l 23.924 -28.179 c 4.809 -5.666 7.456 -12.868 7.456 -20.279 c 0 -8.382 -3.264 -16.262 -9.19 -22.189 C 61.263 5.264 53.383 2 45 2 z"
          style={{ fill: "#58a4ae" }}
        />
        <path
          d="M 45 55.734 c -12.94 0 -23.468 -10.528 -23.468 -23.468 S 32.06 8.798 45 8.798 s 23.468 10.528 23.468 23.468 S 57.94 55.734 45 55.734 z M 45 10.798 c -11.837 0 -21.468 9.631 -21.468 21.468 S 33.163 53.734 45 53.734 c 11.837 0 21.468 -9.631 21.468 -21.468 S 56.837 10.798 45 10.798 z"
          style={{ fill: "#58a4ae" }}
        />
        <path
          d="M 45 90 c -13.181 0 -26.524 -2.697 -26.524 -7.854 c 0 -3.468 5.883 -5.406 10.819 -6.422 c 0.539 -0.111 1.07 0.236 1.181 0.778 c 0.111 0.541 -0.237 1.069 -0.778 1.181 c -6.371 1.311 -9.222 3.186 -9.222 4.463 C 20.476 84.591 29.806 88 45 88 s 24.524 -3.409 24.524 -5.854 c 0 -1.277 -2.852 -3.152 -9.222 -4.463 c -0.541 -0.111 -0.89 -0.64 -0.778 -1.181 s 0.64 -0.886 1.181 -0.778 c 4.936 1.016 10.819 2.954 10.819 6.422 C 71.524 87.303 58.181 90 45 90 z"
          style={{ fill: "#58a4ae" }}
        />
        <path
          d="M 52.5 19.938 c -0.553 0 -1 0.448 -1 1 v 9.9 h -13 v -9.9 c 0 -0.552 -0.448 -1 -1 -1 s -1 0.448 -1 1 v 21.8 c 0 0.552 0.448 1 1 1 s 1 -0.448 1 -1 v -9.9 h 13 v 9.9 c 0 0.552 0.447 1 1 1 s 1 -0.448 1 -1 v -21.8 C 53.5 20.386 53.053 19.938 52.5 19.938 z"
          style={{ fill: "rgb(0,0,0)" }}
        />
      </g>
    </svg>
  );
};

export default HotelPlaceholder;
